// src/utils/validation.ts

export interface FormData {
  name: string;
  email: string;
  tel: string;
  subject: string;
  message: string;
  to_name: string;
  privacyAgreement: boolean;
}

export interface FormErrors {
  name?: string;
  email?: string;
  tel?: string;
  subject?: string;
  message?: string;
  privacyAgreement?: string;
}

export const validateForm = (formData: FormData): FormErrors => {
  const { name, email, tel, subject, message, privacyAgreement } = formData;
  const newErrors: FormErrors = {};

  if (!name) newErrors.name = "Naam & Voornaam verplicht.";
  if (!email) {
    newErrors.email = "Email verplicht.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    newErrors.email = "Geen geldige email adres.";
  }

  if (!tel) {
    newErrors.tel = "Telefoonnummer verplicht.";
  } else if (
    !/^(\+?32|0\d{1,9}|33|0\d{1,9}|31|0\d{1,9}|49|0\d{1,15})\d{8,15}$/.test(tel)
  ) {
    newErrors.tel = "Geen geldig telefoonnummer.";
  }

  if (!subject) newErrors.subject = "Onderwerp is verplicht.";
  if (!message) newErrors.message = "Bericht is verplicht.";
  if (!privacyAgreement)
    newErrors.privacyAgreement = "Het accepteren van het privacybeleid is verplicht.";

  return newErrors;
};
